import React from "react";
import { Avatar, Button, DetailCard } from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";

const Skills = ({ applicant }) => {
  const skills = applicant?.skills || [];
//console.log(applicant)
  return (
    <div className="p-4">
      {skills.map((item) => (
        <div key={item._id} className="mb-4">  {/* Same space between cards */}
          <DetailCard
            size="xs"
            title={
              <div className="flex items-center gap-x-5 gap-y-2">
                <Avatar showInitials alt={formatWords2(item.name)} noBorder />
                <div className="font-bold text-xs capitalize">{formatWords2(item.name)}</div>
              </div>
            }
            headeRight={
              <div className="p-2">
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </div>
            }
          >
            <div className="my-2 mx-1 text-sm p-2">
              <div className="font-semibold text-sm capitalize">
                {formatWords2(item.name)}
              </div>

              <div className="mt-1">
                Experience: {item.exp} year(s)
              </div>
            </div>
          </DetailCard>
        </div>
      ))}
    </div>
  );
};

export default Skills;
